<app-base-edit-form-modal
  [fields]="fields"
  [id]="id"
  [parentId]="productId"
  [baseService]="supplierProductService"
  (saved)="saved()"
>
</app-base-edit-form-modal>
